import { type SchemaOrgFragmentFragment } from '@packages/gql/generated/shopping/graphql';

export type GetRatingTagsType = {
  ratingForSchema: SchemaOrgFragmentFragment['ratingForSchema'];
  name: SchemaOrgFragmentFragment['name'];
  description: string;
};

export const getRatingTags = ({ ratingForSchema, name, description }: GetRatingTagsType) => {
  if (!ratingForSchema || !ratingForSchema?.product) {
    return '';
  }

  const {
    product: {
      tags: { pro, contra },
    },
  } = ratingForSchema;

  const pros =
    pro?.map(({ tag }, index) => ({
      '@type': 'ItemList',
      position: index + 1,
      name: tag.name,
    })) || [];

  const contras =
    contra?.map(({ tag }, index) => ({
      '@type': 'ItemList',
      position: index + 1,
      name: tag.name,
    })) || [];

  return JSON.stringify({
    '@type': 'Review',
    name,
    description,
    positiveNotes: {
      '@type': 'ItemList',
      itemListElement: pros,
    },
    negativeNotes: {
      '@type': 'ItemList',
      itemListElement: contras,
    },
  });
};
